// src/routes/MonitoringRoutes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Field Submissions
import FieldSubmissionList   from '../pages/monitoring/submissions/FieldSubmissionList';
import FieldSubmissionDetail from '../pages/monitoring/submissions/FieldSubmissionDetail';

// Issues Tracking
import IssuesList from '../pages/monitoring/issues/IssuesList';
import IssueForm  from '../pages/monitoring/issues/IssueForm';

// Progress Monitoring
import ProgressList              from '../pages/monitoring/progress/ProgressList';
import ProjectProgressDetail     from '../pages/monitoring/progress/ProjectProgressDetail';
import SegmentProgressDetail     from '../pages/monitoring/progress/SegmentProgressDetail';
import TowerSiteProgressDetail   from '../pages/monitoring/progress/TowerSiteProgressDetail';
import MilestoneProgressUpdate   from '../pages/monitoring/progress/MilestoneProgressUpdate';

/**
 * Monitoring Routes
 *
 * /monitoring
 *   /submissions                           — Field submission list (grouped by segment/site)
 *   /submissions/segment/:segmentId        — Detail + approval page for FO Segment ✅ NEW
 *   /submissions/site/:siteId              — Detail + approval page for Tower Site  ✅ NEW
 *   /issues                               — Issues tracking
 *   /issues/create                        — Create new issue
 *   /progress                             — Progress monitoring
 *   /progress/:projectId                  — Project progress detail
 *   /progress/segment/:segmentId          — FO Segment progress detail
 *   /progress/site/:siteId               — Tower Site progress detail
 *   /progress/milestone/:milestoneId      — Milestone progress update
 *
 * ROUTE ORDER NOTE:
 * /submissions/segment/:segmentId dan /submissions/site/:siteId
 * harus dideklarasikan SEBELUM /submissions agar tidak ter-override
 * oleh catch-all. React Router v6 sudah handle ini dengan baik
 * (most specific wins), tapi explicit ordering tetap best practice.
 */
const MonitoringRoutes = () => {
  return (
    <Routes>
      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/monitoring/progress" replace />} />

      {/* ── Field Submissions ──────────────────────────────────────────── */}

      {/* List — grouped by segment/site, global submit/upload buttons */}
      <Route path="/submissions" element={<FieldSubmissionList />} />

      {/* Detail — two-panel approval page untuk FO Segment */}
      <Route
        path="/submissions/segment/:segmentId"
        element={<FieldSubmissionDetail />}
      />

      {/* Detail — two-panel approval page untuk Tower Site */}
      <Route
        path="/submissions/site/:siteId"
        element={<FieldSubmissionDetail />}
      />

      {/* ── Issues Tracking ────────────────────────────────────────────── */}

      <Route path="/issues"        element={<IssuesList />} />
      <Route path="/issues/create" element={<IssueForm />} />

      {/* ── Progress Monitoring ────────────────────────────────────────── */}

      <Route path="/progress"                          element={<ProgressList />} />
      <Route path="/progress/:projectId"               element={<ProjectProgressDetail />} />
      <Route path="/progress/segment/:segmentId"       element={<SegmentProgressDetail />} />
      <Route path="/progress/site/:siteId"             element={<TowerSiteProgressDetail />} />
      <Route path="/progress/milestone/:milestoneId"   element={<MilestoneProgressUpdate />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/monitoring/progress" replace />} />
    </Routes>
  );
};

export default MonitoringRoutes;